import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { TTrapVariables } from '../../Reports/_utils/getReportVariablesForQuery'

export const convertLocalTrapCatchesReportToAPIFormat = (
  variables: TTrapVariables,
): NonNullable<
  routes.LegacyWeeklyTrapCatchesReportsManagement.Request['legacyWeeklyTrapCatchesReportsToCreate']
>[number] => {
  return {
    name: variables.name,
    contacts:
      variables.contacts?.map((c) => ({
        contactId: c,
      })) ?? [],
    groups:
      variables.groups?.map((g) => ({
        groupId: g,
      })) ?? [],
    notifyOwnerByEmail: variables.notifyOwnerByEmail,
    dayOfWeek: variables.rules?.dayOfWeek,
    startDate: variables.rules?.startDate ?? null,
    endDate: variables.rules?.endDate ?? null,
    rules:
      Object.values(variables.rules.pests ?? {}).reduce((acc, pest) => {
        if (pest?.insectId && pest?.startDate && pest?.endDate) {
          acc.push({
            insectId: pest.insectId,
            startDate: pest.startDate,
            endDate: pest.endDate,
          })
        }

        return acc
      }, [] as NonNullable<routes.LegacyWeeklyTrapCatchesReportsManagement.Request['legacyWeeklyTrapCatchesReportsToCreate']>[number]['rules']) ??
      [],
    propertyIds: variables.rules?.propertyIds?.length
      ? (variables.rules?.propertyIds?.map((p) => +p) as [number, ...number[]])
      : null,
  } as NonNullable<
    routes.LegacyWeeklyTrapCatchesReportsManagement.Request['legacyWeeklyTrapCatchesReportsToCreate']
  >[number]
}
